// Chakra imports
import { Flex, Image } from '@chakra-ui/react';
import logo from "assets/img/logo/logo.png"

// Custom components
import { HSeparator } from 'components/separator/Separator';

export function SidebarBrand() {
	//   Chakra color mode

	return (
		<Flex alignItems='center' flexDirection='column'>
			<Image src={logo} h='60px' w='60px' ml="-20px" mb="20px"/>
			<HSeparator mb='20px' />
		</Flex>
	);
}

export default SidebarBrand;
